import RegModlinkContainer from "../../../../components/units/Management/Device/regModlink/regModlinkContainer";

export default function DeviceRegisterPage() {
  return <RegModlinkContainer />;
}
